// WI-S3.1 (BLOCKER-1) — the loggable window opens at the 1st of the
// LOCAL month. Extracted from WorkItemDrawer into a standalone module
// so Jest can pin the boundary without pulling in the axios-heavy
// import chain of the drawer.
//
// MT-S3 amendment (2026-07-09) — the upper (today) bound is retired:
// PO ruled future days LEGAL for logging. The window is now
// [1st of local month .. +∞); only the lower bound is enforced, so
// past-months entries stay in their prior-months read-only summary
// row while today AND future days are directly editable.
//
// All date operations use LOCAL calendar values: toLocaleDateString
// with the 'sv-SE' locale yields YYYY-MM-DD in the browser TZ, which
// is exactly the shape the backend's date-only fields carry. ISO
// string comparison side-steps the time-of-day pitfall (a `pickedDay`
// created via `new Date()` mid-day was pushed past midnight `today`).

const isoOf = (d) => (d instanceof Date && !isNaN(d) ? d.toLocaleDateString('sv-SE') : '');

const firstOfMonth = (d) => {
  const x = new Date(d);
  x.setDate(1);
  x.setHours(0, 0, 0, 0);
  return x;
};

const startOfLocalToday = () => {
  const x = new Date();
  x.setHours(0, 0, 0, 0);
  return x;
};

export const isInHoursWindow = (dateOrIso, todayOverride) => {
  const iso = typeof dateOrIso === 'string' ? dateOrIso : isoOf(dateOrIso);
  if (!iso) return false;
  const today = todayOverride instanceof Date ? todayOverride : startOfLocalToday();
  const monthStart = isoOf(firstOfMonth(today));
  // MT-S3 amendment — no upper bound; future days are in-range.
  return iso >= monthStart;
};

export { isoOf, firstOfMonth, startOfLocalToday };
